import config from 'config';
import { RestfulGCSWebService, GCSWebService } from 'ws/GCSWebService';

export interface CloudStorageManager {
  uploadFileToCloud (file: File, isVideo?: boolean): Promise<string>;
}
export class GCSManager implements CloudStorageManager {

  constructor (
    private webService: GCSWebService = new RestfulGCSWebService()
  ) {}

  async uploadFileToCloud (file: File, isVideo: boolean = false) {
    const bucket = isVideo
      ? config.cloudStorageConfig.media_bucket
      : config.cloudStorageConfig.bucket;
    return this.webService.uploadFileToCloudByPresignedUrl(file, bucket);
  }
}
